import {appendQueryString, getExternalRequest} from "@pg-mono/request";

import {osmApiUrl} from "../../app/read_rp_environment_variables";
import {IOSMPoisRoutesGrouped} from "../actions/fetch_osm_pois_routes_grouped";
import {OSMPoiRoutesUrl} from "../constants/osm_api_routes";
import {IPoiAround} from "../types/IPoiAround";

type IGetRouteQuery = {
    point: string;
    dist: number;
    cache_timeout?: number;
};

export async function getRoutes(params: IPoiAround, cacheTimeout?: number) {
    if (osmApiUrl === null) {
        throw new Error("env: OSM_API_URL is not defined");
    }

    const query: IGetRouteQuery = {
        point: `${params.latitude},${params.longitude}`,
        dist: params.radius
    };

    if (cacheTimeout) {
        query.cache_timeout = cacheTimeout;
    }

    const url = appendQueryString(OSMPoiRoutesUrl, query);

    try {
        return (await getExternalRequest({}, url, 5000)) as IOSMPoisRoutesGrouped;
    } catch {
        return null;
    }
}
import {appendQueryString, getExternalRequest} from "@pg-mono/request";

import {osmApiUrl} from "../../app/read_rp_environment_variables";
import {IOSMPoisRoutesGrouped} from "../actions/fetch_osm_pois_routes_grouped";
import {OSMPoiRoutesUrl} from "../constants/osm_api_routes";
import {IPoiAround} from "../types/IPoiAround";

type IGetRouteQuery = {
    point: string;
    dist: number;
    cache_timeout?: number;
};

export async function getRoutes(params: IPoiAround, cacheTimeout?: number) {
    if (osmApiUrl === null) {
        throw new Error("env: OSM_API_URL is not defined");
    }

    const query: IGetRouteQuery = {
        point: `${params.latitude},${params.longitude}`,
        dist: params.radius
    };

    if (cacheTimeout) {
        query.cache_timeout = cacheTimeout;
    }

    const url = appendQueryString(OSMPoiRoutesUrl, query);

    try {
        return (await getExternalRequest({}, url, 5000)) as IOSMPoisRoutesGrouped;
    } catch {
        return null;
    }
}
